import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function CTASection() {
  const { config } = useSite();
  const wa = `https://wa.me/${config?.whatsapp}?text=${encodeURIComponent("Olá, gostaria de uma proposta da DeskcodeBR.")}`;
  return (
    <section data-testid="cta-section" className="section-padding bg-gradient-to-br from-[#1A1858] via-[#2E2A8C] to-[#0a0a2e] relative overflow-hidden">
      <div className="absolute inset-0 tech-grid opacity-30"></div>
      <div className="glow-orb w-[600px] h-[600px] -top-40 -right-40 bg-dc-accent/30"></div>
      <div className="dc-container relative text-center">
        <span className="text-xs font-semibold uppercase tracking-[0.25em] text-dc-accent">Pronto para evoluir?</span>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 mb-5 max-w-3xl mx-auto leading-tight">
          Vamos transformar a tecnologia da sua empresa em uma vantagem competitiva
        </h2>
        <p className="text-base md:text-lg text-blue-100 max-w-2xl mx-auto mb-9">
          Solicite um orçamento sem compromisso ou agende uma visita técnica para diagnóstico completo da sua infraestrutura.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/orcamento"
            data-testid="cta-orcamento"
            className="inline-flex items-center gap-2 bg-white text-dc-secondary hover:bg-dc-accent px-8 py-4 rounded-full font-semibold transition shadow-2xl hover:-translate-y-0.5"
          >
            Solicitar orçamento <ArrowRight className="w-4 h-4" />
          </Link>
          <a
            href={wa}
            target="_blank"
            rel="noreferrer"
            data-testid="cta-whatsapp"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb557] text-white px-8 py-4 rounded-full font-semibold transition shadow-xl"
          >
            <MessageCircle className="w-4 h-4" /> Falar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
